import axios from 'axios';

const CreditReportService = {
  async createCreditReportTradeline({ formValues, id }) {
    const response = await axios.post(
      `/credit-reports/${id}/tradelines`,
      formValues
    );

    return response.data;
  },
};

export default CreditReportService;
